import { Mail, Send, UserPlus } from "lucide-react";
import { useEffect, useState } from "react";

import { api, formatApiError } from "@/lib/api";


export default function ManagersPage() {
  const [stores, setStores] = useState([]);
  const [managers, setManagers] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", store_ids: [] });
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");

  const loadData = async () => {
    try {
      const [storeResponse, managerResponse] = await Promise.all([
        api.get("/stores"),
        api.get("/users/managers"),
      ]);
      setStores(storeResponse.data);
      setManagers(managerResponse.data);
    } catch (requestError) {
      setError(formatApiError(requestError));
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const toggleFormStore = (storeId) => {
    setForm((current) => ({
      ...current,
      store_ids: current.store_ids.includes(storeId)
        ? current.store_ids.filter((item) => item !== storeId)
        : [...current.store_ids, storeId],
    }));
  };

  const createManager = async (event) => {
    event.preventDefault();
    setError("");
    setNotice("");
    try {
      await api.post("/users/managers", form);
      setForm({ name: "", email: "", store_ids: [] });
      setNotice("Manager dibuat dan tautan reset password dikirim melalui email.");
      await loadData();
    } catch (requestError) {
      setError(formatApiError(requestError));
    }
  };

  const updateAssignments = async (manager, storeId) => {
    const storeIds = manager.store_ids.includes(storeId)
      ? manager.store_ids.filter((item) => item !== storeId)
      : [...manager.store_ids, storeId];
    setError("");
    try {
      await api.patch(`/users/managers/${manager.user_id}`, { store_ids: storeIds });
      await loadData();
    } catch (requestError) {
      setError(formatApiError(requestError));
    }
  };

  const sendReset = async (managerId) => {
    setError("");
    try {
      await api.post(`/users/managers/${managerId}/send-reset`);
      setNotice("Email reset password Manager telah dikirim.");
    } catch (requestError) {
      setError(formatApiError(requestError));
    }
  };

  return (
    <main className="workspace" data-testid="managers-page">
      <section className="page-heading">
        <div>
          <p className="eyebrow">AKSES MANAGER</p>
          <h1 data-testid="managers-page-title">Tim dan cakupan toko</h1>
        </div>
      </section>
      {error && <p className="form-error" data-testid="managers-error" role="alert">{error}</p>}
      {notice && <p className="form-success" data-testid="managers-success">{notice}</p>}

      <section className="form-section" aria-labelledby="add-manager-title">
        <div className="section-heading"><div><p className="eyebrow">ADMIN</p><h2 id="add-manager-title">Buat Manager</h2></div></div>
        <form className="grid-form" data-testid="create-manager-form" onSubmit={createManager}>
          <label htmlFor="manager-name">Nama Manager
            <input data-testid="manager-name-input" id="manager-name" onChange={(event) => setForm({ ...form, name: event.target.value })} required value={form.name} />
          </label>
          <label htmlFor="manager-email">Email Manager
            <input data-testid="manager-email-input" id="manager-email" onChange={(event) => setForm({ ...form, email: event.target.value })} required type="email" value={form.email} />
          </label>
          <fieldset className="wide-field" data-testid="manager-store-assignment-fieldset">
            <legend>Akses toko</legend>
            <div className="checkbox-list">
              {stores.map((store) => (
                <label key={store.store_id}>
                  <input checked={form.store_ids.includes(store.store_id)} data-testid={`new-manager-store-${store.store_id}`} onChange={() => toggleFormStore(store.store_id)} type="checkbox" />
                  {store.name}
                </label>
              ))}
            </div>
          </fieldset>
          <button className="form-action" data-testid="create-manager-submit-button" type="submit">
            <UserPlus aria-hidden="true" size={17} /> Buat dan kirim tautan
          </button>
        </form>
      </section>

      <section className="data-section" aria-labelledby="manager-list-title">
        <div className="section-heading"><div><p className="eyebrow">DAFTAR AKUN</p><h2 id="manager-list-title">Manager aktif</h2></div></div>
        <div className="manager-list" data-testid="manager-list">
          {managers.map((manager) => (
            <article className="manager-row" data-testid={`manager-${manager.user_id}`} key={manager.user_id}>
              <div>
                <strong>{manager.name}</strong>
                <p><Mail aria-hidden="true" size={14} /> {manager.email}</p>
                <div className="assignment-list" data-testid={`manager-assignments-${manager.user_id}`}>
                  {stores.map((store) => (
                    <label key={store.store_id}>
                      <input checked={manager.store_ids.includes(store.store_id)} data-testid={`manager-${manager.user_id}-store-${store.store_id}`} onChange={() => updateAssignments(manager, store.store_id)} type="checkbox" />
                      {store.code}
                    </label>
                  ))}
                </div>
              </div>
              <button className="icon-text-button secondary" data-testid={`send-manager-reset-${manager.user_id}`} onClick={() => sendReset(manager.user_id)} type="button">
                <Send aria-hidden="true" size={16} /> Kirim reset
              </button>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}